<div class="page-wrapper">
  <div class="success-card">

    <!-- Animated Check -->
    <div class="check-wrap">
      <div class="check-ring check-ring--outer"></div>
      <div class="check-ring check-ring--inner"></div>
      <svg class="check-svg" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="check-circle" cx="26" cy="26" r="24" stroke="#22c55e" stroke-width="2.5"/>
        <path class="check-mark" d="M14 26l8 8 16-16" stroke="#22c55e" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <h1 class="success-title">You're All Set!</h1>
    <p class="success-subtitle">
      Your institution has been successfully registered and your subscription is now active.
    </p>

    <!-- Info Alert -->
    <div class="info-alert">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <div>
        <strong>Check your inbox</strong>
        <p>We've sent a confirmation email with your account details. Your account will be activated shortly by our team.</p>
      </div>
    </div>

    <!-- What's Next -->
    <div class="next-steps">
      <h3 class="next-steps-title">What happens next?</h3>
      <div class="steps-list">
        <div class="step-item">
          <div class="step-num">1</div>
          <div class="step-text">
            <strong>Account Activation</strong>
            <span>Our team will activate your account within 24 hours.</span>
          </div>
        </div>
        <div class="step-item">
          <div class="step-num">2</div>
          <div class="step-text">
            <strong>Onboarding Call</strong>
            <span>A dedicated onboarding specialist will reach out to schedule your setup call.</span>
          </div>
        </div>
        <div class="step-item">
          <div class="step-num">3</div>
          <div class="step-text">
            <strong>Go Live</strong>
            <span>Start managing your institution on the aInstitute platform.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-actions">
      <a href="https://ainstitute.cloud" class="btn-primary" target="_blank">
        Visit aInstitute
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </div>

  </div>
</div>
